/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewgreetingen4Inputs */

const en_letterpreviewgreetingen4 = /** @type {(inputs: Letterpreviewgreetingen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dear Sir/Madam,`)
};

const pt_letterpreviewgreetingen4 = /** @type {(inputs: Letterpreviewgreetingen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dear Sir/Madam,`)
};

/**
* | output |
* | --- |
* | "Dear Sir/Madam," |
*
* @param {Letterpreviewgreetingen4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewgreetingen4 = /** @type {((inputs?: Letterpreviewgreetingen4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewgreetingen4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewgreetingen4(inputs)
	return pt_letterpreviewgreetingen4(inputs)
});
export { letterpreviewgreetingen4 as "letterPreviewGreetingEN" }